import { render, staticRenderFns } from "./WorkspaceSelector.vue?vue&type=template&id=cad280e4&scoped=true&"
import script from "./WorkspaceSelector.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSelector.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSelector.vue?vue&type=style&index=0&id=cad280e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad280e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad280e4')) {
      api.createRecord('cad280e4', component.options)
    } else {
      api.reload('cad280e4', component.options)
    }
    module.hot.accept("./WorkspaceSelector.vue?vue&type=template&id=cad280e4&scoped=true&", function () {
      api.rerender('cad280e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/settings/WorkspaceSelector.vue"
export default component.exports